import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./style.css";

const FinalSubmission = ({ submitHandler, children }) => {
  const [isSubmissionDone, setIsSubmissionDone] = useState(false);
  return (
    <Form>
      <Modal.Body className="selectNewAccessType_modalBody">
        <Form.Row style={{ margin: "30px 0px 70px 0px" }}>{children}</Form.Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ float: "right" }}
          className="button-primary-md"
          type="submit"
          disabled={isSubmissionDone}
          onClick={() => {
            setIsSubmissionDone(true);
            submitHandler();
          }}
          disabled={isSubmissionDone}
        >
          OK
        </Button>
      </Modal.Footer>
    </Form>
  );
};
export default FinalSubmission;
